import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'upsc-detail-verification',
  templateUrl: './detail-verification.component.html',
  styleUrls: ['./detail-verification.component.scss']
})
export class DetailVerificationComponent implements OnInit {

  showSpinner = false;
  showEmailVerification = false;
  userDetails: any = {};
  systemError = false;
  iShipCheckShipmentData = null;
  loading: boolean = false;
  emailAddress: string = '';

  constructor(
    private accountService: AccountService,
    private auth: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    sessionStorage.setItem('userDetails', JSON.stringify({ ...JSON.parse(sessionStorage.getItem('userDetails')!), stage: 'post' }));
    this.userDetails = JSON.parse(sessionStorage.getItem('userDetails')!);
    this.emailAddress = this.userDetails.emailAddress;
    this.determineLoginState();   
  }  
  
    //Check if user is authenticated
    determineLoginState() {
      this.loading = true;
      this.auth.isLoading$.pipe(
        filter(loading => !loading),
        take(1),
        switchMap(() => this.auth.idTokenClaims$),
        take(1)
      ).subscribe(
        response => {
          if (!response) {
            this.initiatePasswordlessAuth();
          } else {
            if (response.__raw && response.email) {
              if (response.email.toLowerCase() == this.emailAddress.toLowerCase()) {
                this.setTokenAndGetPolicy(response.__raw);
              } else {
                this.loading = false;
                this.systemError = true;
              }
            } else {
              this.loading = false;
              this.systemError = true;
            }
          }
        }, error => {
          //There was an error on the /token endpoint, likely meaning user's session was invalid. Go to passwordless flow.
          this.initiatePasswordlessAuth();
        }
      );
    }
  
    initiatePasswordlessAuth() {
      this.auth.loginWithRedirect({
        authorizationParams: {
          connection: 'email',
          login_hint: this.emailAddress.toLowerCase(),  //Pre-fill the email with the email address the claim was filed on
          redirect_uri: `${environment.baseUrl.web}callback`,
          'ext-connect': 'email', //additional param to indicate template to hide "sign up" and "login" text
          'ext-type': 'hint',  //Disables the user to enter in their own email https://auth0.com/docs/customize/login-pages/universal-login/customize-templates#custom-query-parameters
          'ext-style': 'tupss'
          //redirect_uri: `${'http://localhost:4200/'}callback`
        },
        appState: { target: '/tupss/detail-verification' }
      });
    }

    setTokenAndGetPolicy(id_token: string) {
    let request = {
      id_token: id_token,
      workflow: 'tccp'
    }
    this.accountService.storePasswordlessToken(request).subscribe(
      response => {
        this.router.navigate(['/tupss/detail'], { queryParams: { claimNumber: this.userDetails.claimNumber } });
      }, error => {
        //console.log("couldn't store token in database, show an error");
        this.loading = false;
        this.systemError = true;
      }
    );
  }


  // startVerificationCodeProcess() {
  //   this.showSpinner = true;
  //   //First get iship data from trackNo. Data is used in email template.
  //   this.tupssService.getIShipData({ transactionSrc: "Capital_TFCP", trackNo: this.userDetails.trackingNumber }).subscribe(
  //     data => {
  //       this.iShipCheckShipmentData = data.data;
  //       this.createAndSendVerificationCode();
  //     }, error => {
  //       this.createAndSendVerificationCode();
  //     }
  //   );
  // }

  // createAndSendVerificationCode() {
  //   let request;
  //   if (this.iShipCheckShipmentData) {
  //     request = {
  //       ...emptyIEmail,
  //       emailFor: 'TCCPClaimSuccessVerificationCode',
  //       data: {
  //         emailAddress: this.userDetails.emailAddress,
  //         firstName: this.iShipCheckShipmentData.name ? this.iShipCheckShipmentData.name : this.iShipCheckShipmentData.companyName ? this.iShipCheckShipmentData.companyName : '',
  //         lastName: '',
  //         companyName: this.iShipCheckShipmentData.companyName ? this.iShipCheckShipmentData.companyName : '',
  //         city: this.iShipCheckShipmentData.city ? this.iShipCheckShipmentData.city : '',
  //         zip: this.iShipCheckShipmentData.zip ? this.iShipCheckShipmentData.zip : '',
  //         state: this.iShipCheckShipmentData.state ? this.iShipCheckShipmentData.state : '',
  //         streetAddress: this.iShipCheckShipmentData.address1 ? this.iShipCheckShipmentData.address1 : ''
  //       }
  //     }
  //   } else {
  //     request = {
  //       ...emptyIEmail,
  //       emailFor: 'TCCPClaimSuccessVerificationCode',
  //       data: {
  //         emailAddress: this.userDetails.emailAddress,
  //         firstName: '',
  //         lastName: '',
  //         companyName: '',
  //         city: '',
  //         zip: '',
  //         state: '',
  //         streetAddress: ''
  //       }
  //     }
  //   }

  //   this.accountService.createVerificationCode(request).subscribe(
  //     data => {
  //       this.showSpinner = false;
  //       if (data && data.responseMessage) {
  //         this.showEmailVerification = true;
  //       } else {
  //         this.showEmailVerification = false;
  //         this.systemError = true;
  //       }
  //     }, error => {
  //       this.showSpinner = false;
  //       this.showEmailVerification = false;
  //       this.systemError = true;
  //     }
  //   );
  // }

}
